// extracted by mini-css-extract-plugin
module.exports = {"multimodal-wrapper":"multi-equipment-modal_multimodal-wrapper__QUFsV"};